import type { RootState } from "@/types";
import type { CpeRapport } from "@/types/cpe";
import type { CperapportState } from "@/types/store";
import type { GetterTree } from "vuex";

export const getters: GetterTree<CperapportState, RootState> = {
  getCperapports(state): CpeRapport[] {
    return state.cperapports.data;
  },
  getCperapportsCount(state): number {
    return state.cperapports.count;
  },
  getCperapportsLoading(state): boolean {
    return state.cperapports.loading;
  },
  getCperapportsError(state): string | null {
    return state.cperapports.error;
  },
  getCperapport(state): CpeRapport {
    return state.cperapport.data;
  },
};
